<div class="full-container" *ngIf="!isDesktopScreen">
  <div class="arrow-container">
    <app-header [configuration]="headerConfiguration" (onClickButton)="handleBackClick()"></app-header>
    <img class="ingood-logo" src="assets/img/ingood_vertical_negativo@2x.png" alt="ingood" />
  </div>
  <div class="form-header">
    <mat-divider></mat-divider>
    <div class="title">Datos de pago</div>
    <div class="card-icons">
      <mat-icon svgIcon="masterdCard-icon"></mat-icon>
      <img class="visa-img" src="/assets/icons/visa-white.png" />
    </div>
  </div>
  <div class="payment-wrapper">
    <div class="policy-summary">
      <label class="summary-title"><strong>Resumen de compra</strong></label>
      <p><strong>Seguro anual:</strong> {{ policySummary.product }}</p>
      <p><strong>Fecha vencimiento:</strong> {{ policySummary.expirationDate }}</p>
      <p><strong>Importe:</strong> {{ policySummary.price}}</p>
    </div>
    <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="form-content">
      <label>Número de tarjeta</label>
      <input formControlName="cardNumber" maxlength="19" (input)="onCardNumberInput($event)" (paste)="onCardNumberPaste($event)" inputmode="numeric" (keypress)="onCardKeyPress($event)" pattern="[0-9]*"/>
      <div class="error" *ngIf="paymentForm.get('cardNumber')?.touched && paymentForm.get('cardNumber')?.invalid">
        <div *ngIf="paymentForm.get('cardNumber')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="paymentForm.get('cardNumber')?.errors?.['pattern']">Formato inválido</div>
      </div>

      <label>Fecha de caducidad</label>
      <mat-form-field class="custom-datepicker">
        <input matInput [matDatepicker]="picker" formControlName="expiryDate" [min]="minDate" [max]="maxDate" readonly (click)="picker.open()"/>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker id="picker" #picker startView="multi-year" [touchUi]="true"
          (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, picker)"></mat-datepicker>
      </mat-form-field>

      <label>CVV</label>
      <input type="password" formControlName="cvv" maxlength="3" />
      <div class="error" *ngIf="paymentForm.get('cvv')?.touched && paymentForm.get('cvv')?.invalid">
        <div *ngIf="paymentForm.get('cvv')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="paymentForm.get('cvv')?.errors?.['pattern']">Debe tener 3 dígitos</div>
      </div>

      <div class="consents-container">
        <section class="checkbox-section">
          <mat-checkbox class="checkbox" formControlName="termsAccepted"></mat-checkbox>
          <div class="consents-text" style="font-size: 12px; color: #5f6873;"  [innerHTML]="htmlConsents"></div>
        </section>
        <div class="error"
          *ngIf="paymentForm.get('termsAccepted')?.invalid && paymentForm.get('termsAccepted')?.touched">
          Debes aceptar los términos y condiciones para continuar.
        </div>
      </div>
      <button type="submit" class="contract-button" [disabled]="isContinueDisabled" [class.disabled]="isContinueDisabled">Contratar</button>
    </form>
  </div>
</div>

<div class="full-container" *ngIf="isDesktopScreen">
  <div class="img-container">
    <img class="ingood-logo" src="assets/img/ingood_vertical_negativo@2x.png" alt="ingood" />
    <img [src]="whiteHandIcon">
  </div>
  <div class="payment-wrapper">
    <div class="arrow-container" *ngIf="isDesktopScreen">
      <app-header [configuration]="headerConfiguration" (onClickButton)="handleBackClick()"></app-header>
    </div>
    <div class="form-header">
      <mat-divider></mat-divider>
      <div class="title">Datos de pago</div>
      <div class="card-icons">
        <mat-icon svgIcon="masterdCard-icon"></mat-icon>
        <img class="visa-img" src="/assets/icons/visa.png" />
      </div>
    </div>

    <div class="policy-summary">
      <label class="summary-title"><strong>Resumen de compra</strong></label>
      <p><strong>Seguro anual:</strong> {{ policySummary.product }}</p>
      <p><strong>Fecha vencimiento:</strong> {{ policySummary.expirationDate }}</p>
      <p><strong>Importe:</strong> {{ policySummary.price}}</p>
    </div>

    <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="form-content">
      <label>Número de tarjeta</label>
      <input formControlName="cardNumber" maxlength="19" (input)="onCardNumberInput($event)" (paste)="onCardNumberPaste($event)" inputmode="numeric" pattern="[0-9]*"/>
      <div class="error" *ngIf="paymentForm.get('cardNumber')?.touched && paymentForm.get('cardNumber')?.invalid">
        <div *ngIf="paymentForm.get('cardNumber')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="paymentForm.get('cardNumber')?.errors?.['checkCreditCard']">Formato inválido</div>
      </div>

      <label>Fecha de caducidad</label>
      <mat-form-field class="custom-datepicker">
        <input matInput [matDatepicker]="picker" formControlName="expiryDate" [min]="minDate" [max]="maxDate" readonly (click)="picker.open()"/>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker id="picker" #picker startView="multi-year" [touchUi]="true"
          (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, picker)"></mat-datepicker>
      </mat-form-field>

      <label>CVV</label>
      <input type="password" formControlName="cvv" maxlength="3" />
      <div class="error" *ngIf="paymentForm.get('cvv')?.touched && paymentForm.get('cvv')?.invalid">
        <div *ngIf="paymentForm.get('cvv')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="paymentForm.get('cvv')?.errors?.['pattern']">Debe tener 3 dígitos</div>
      </div>

      <div class="consents-container">
        <section class="checkbox-section">
          <mat-checkbox class="checkbox" formControlName="termsAccepted"></mat-checkbox>
          <div class="consents-text" style="font-size: 12px; color: #5f6873;"  [innerHTML]="htmlConsents"></div>
        </section>
        <div class="error"
          *ngIf="paymentForm.get('termsAccepted')?.invalid && paymentForm.get('termsAccepted')?.touched">
          Debes aceptar los términos y condiciones para continuar.
        </div>
      </div>
      <button type="submit" class="contract-button" [disabled]="isContinueDisabled" [class.disabled]="isContinueDisabled">Contratar</button>
    </form>
  </div>
</div>
